import theme from '../Theme';

const styles = () => ({
  titleMargin: {
    marginLeft: '0px',
    color: theme.colors.dark10,
    [theme.screenSize.smallerScreen]: {
      marginLeft: '10px',
    },
  },
  titleColor: {
    color: theme.colors.dark10,
  },
  trackOrderMargin: {
    marginTop: '16px',
  },
  mainHeading: {
    fontSize: theme.font.size.md,
    fontWeight: theme.font.weight.medium,
    [theme.screenSize.smallerScreen]: {
      fontSize: theme.font.size.xl,
      fontWeight: theme.font.weight.semibold,
    },
  },
  subHeading: {
    fontSize: theme.font.size.md,
    fontWeight: theme.font.weight.medium,
    marginTop: '12px',
    [theme.screenSize.smallerScreen]: {
      margin: '0px 25px',
    },
  },
  divider: {
    marginTop: '16px',
    marginBottom: '16px',
  },
});

export default styles;
